import React from "react";
import Rekomendasi from "../components/Rekomendasi"

const Rekomendasipage = () => {
    return (
        <>
            <div className="font-primary">
                <Rekomendasi/>
            </div>            
        </>
    );
};

export default Rekomendasipage